import { Modal } from 'components/Modal';
import { Button } from 'components/Button';

import * as S from './DeleteModal.styles';

type DeleteModalProps = {
  onClose: () => void;
  onDelete: Function;
  name?: string;
  customText?: string;
  hasLightOpacity?: boolean;
};

export function DeleteModal(props: DeleteModalProps): React.ReactElement {
  const { name, onClose, onDelete, customText, hasLightOpacity } = props;

  return (
    <Modal onClose={onClose} hasLightOpacity={hasLightOpacity} maxWidth="42rem">
      <S.Container>
        <S.Icon />

        <S.Title fontWeight="bold" scale="base">
          {name ? `Are you sure you want to delete ${name} ?` : customText}
        </S.Title>

        <S.Buttons>
          <Button
            type="button"
            scale="lg"
            textTransform="uppercase"
            onClick={onClose}
            fontFamily="LFT Zeno Condensed"
            motive="filterSecondary"
          >
            cancel
          </Button>

          <Button
            scale="lg"
            type="button"
            textTransform="uppercase"
            onClick={() => onDelete()}
            fontFamily="LFT Zeno Condensed"
            motive="filter"
          >
            confirm
          </Button>
        </S.Buttons>
      </S.Container>
    </Modal>
  );
}
